import React, { useState, useEffect, useRef } from "react";
import client from "../contentfulClient";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const AllCoupons = _ref => {
  let {
    navigate
  } = _ref;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [activehistoryType, setActiveIndex] = useState(0);
  const [memberCoupons, setMemberCoupons] = useState([]);
  const [bitData, setBitData] = useState([]);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [couponCardImage, setCouponCardImage] = useState([]);
  const [posts, setPosts] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [currentTab, setCurrentTab] = useState('ACTIVE');
  const [copySuccess, setCopySuccess] = useState(-1);
  let memberId = localStorage.getItem("memberId");
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        var _entry$fields;
        const entry = await client.getEntry("5uiWCn5q3hWfVCk8oo845c");

        // Check for linked assets or entries and resolve them
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id); // Resolve linked assets
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        // console.log({ ...entry, fields: resolvedFields });
        setCouponCardImage((_entry$fields = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.raffleCardBlue) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.file) === null || _entry$fields === void 0 ? void 0 : _entry$fields.url);
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  const tabRefs = useRef([]);
  useEffect(() => {
    getRaffles({
      bitStatus: "AVAILABLE,PARTIAL_USED"
    });
  }, []);
  const toggleFilter = index => {
    setSkeletonLoading(true);
    setActiveIndex(index);
    if (index == 0) {
      var _posts$fields;
      getRaffles({
        bitStatus: "AVAILABLE,PARTIAL_USED"
      });
      setCouponCardImage(posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.raffleCardBlue) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.file) === null || _posts$fields === void 0 ? void 0 : _posts$fields.url);
      setCurrentTab('ACTIVE');
      scrollToTop();
    } else if (index == 1) {
      var _posts$fields2;
      getRaffles({
        bitStatus: "CANCELLED,USED,EXPIRED"
      });
      setCurrentTab('EXPIRED');
      setCouponCardImage(posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.raffleCardGrey) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.fields) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.file) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.url);
      scrollToTop();
    }
  };
  const getRaffles = async params => {
    let bitStatusParam = "";
    if (params.bitStatus && params.bitStatus != "all") {
      bitStatusParam = "&status=".concat(params.bitStatus);
    }
    const url = hostSrc + "/bolapi/v3/members/".concat(memberId, "/privileges?cdc=COUPON").concat(bitStatusParam, "/");
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      setNextUrl(response.headers.get("Next"));
      let filteredData = await response.json();
      let bitReference = filteredData.map(item => item.bit_reference);
      try {
        const fetchPromises = bitReference.map(endpoint => fetch(hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&bit_id=") + endpoint, {
          method: "GET",
          headers: headers
        }).then(res => res.json()));
        const responses = await Promise.all(fetchPromises);
        // console.log(responses);
        setBitData(responses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setMemberCoupons(filteredData);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const nextCall = async nexturl => {
    const url = nexturl;
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      setNextUrl(response.headers.get("Next"));
      let filteredData = await response.json();
      let bitReference = filteredData.map(item => item.bit_reference);
      try {
        const fetchPromises = bitReference.map(endpoint => fetch(hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&bit_id=") + endpoint, {
          method: "GET",
          headers: headers
        }).then(res => res.json()));
        const responses = await Promise.all(fetchPromises);
        // console.log(responses);
        setBitData([...bitData, ...responses]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setMemberCoupons([...memberCoupons, ...filteredData]);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleShare = async (uniquePrivilegeCode, indexes) => {
    try {
      await navigator.clipboard.writeText(uniquePrivilegeCode);
      setCopySuccess(indexes); // Show success message
      setTimeout(() => setCopySuccess(-1), 2000);
    } catch (error) {
      console.log("Error copying to clipboard:", error);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "all-coupons-container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: " #131e1e",
      position: "sticky",
      top: "0px",
      zIndex: "2",
      padding: "40px 0 15px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "All\xA0", /*#__PURE__*/React.createElement("p", null, "Coupons")), /*#__PURE__*/React.createElement("div", {
    className: "tab-container"
  }, ["active", "expired"].map((label, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    ref: el => tabRefs.current[index] = el,
    className: activehistoryType === index ? "tab selected-tab" : "tab",
    onClick: () => toggleFilter(index)
  }, label)))), /*#__PURE__*/React.createElement("div", {
    className: "all-coupons-container-2"
  }, skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto",
      padding: "10px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 165,
    width: 342,
    borderRadius: 10,
    count: 5,
    style: {
      opacity: "0.2",
      marginBottom: "10px"
    }
  })) : memberCoupons.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "25px"
    }
  }, memberCoupons.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      height: "148px",
      width: "100%",
      backgroundImage: "url(".concat(couponCardImage, ")"),
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat"
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "productImage",
    style: {
      display: "flex",
      width: "40%",
      justifyContent: "space-between",
      backgroundImage: "url(".concat(item.product.logo, ")"),
      backgroundSize: "100%",
      borderRadius: "8px 0 0 8px"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "60%",
      flexDirection: "column",
      padding: "15px 18px",
      lineHeight: "1.7",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  }, item.product.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "13px",
      fontWeight: "400",
      display: "-webkit-box",
      WebkitLineClamp: "3",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      lineHeight: "1.4"
    }
  }, item.product.description)), currentTab == "ACTIVE" ? /*#__PURE__*/React.createElement("div", {
    onClick: () => handleShare(item.privilege_code, index),
    style: {
      fontSize: "13px",
      fontWeight: "600",
      border: copySuccess == index ? "1px dashed #0f9518" : "1px dashed #ADADAD",
      padding: "5px 10px",
      borderRadius: "4px",
      backgroundColor: copySuccess == index ? "#4dcf5733" : "#F6F6F633",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, item.privilege_code, /*#__PURE__*/React.createElement("div", {
    className: copySuccess == index ? "fas fa-file" : ""
  })) : /*#__PURE__*/React.createElement("div", {
    className: "expiredCta"
  }, "EXPIRED")))))), nextUrl && nextUrl != "None" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "auto",
      cursor: "pointer",
      color: "#F1CA83",
      opacity: "1",
      lineHeight: "40px",
      borderRadius: "20px",
      fontWeight: "400",
      padding: "0 20px",
      letterSpacing: "0.5px"
    },
    onClick: () => nextCall(nextUrl)
  }, "View More Coupons", /*#__PURE__*/React.createElement("img", {
    style: {
      transform: "rotate(90deg)",
      width: "20px",
      marginLeft: "5px"
    },
    className: "transactions-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/rightarrow.png"
  })))) : /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "70px auto 15px",
      padding: "60px",
      border: "1px dashed rgb(173, 173, 173)",
      borderRadius: "10px",
      backgroundColor: "rgba(246, 246, 246, 0.2)"
    }
  }, "No Coupons Available") // Safe fallback content
  ));
};
export { AllCoupons };